import { createAsyncThunk } from '@reduxjs/toolkit';
import timeClockApi from '~/apis/timeclock';
import { GET_TIME_CLOCKS } from '~/utils/constants/actionType';
import { IParamsGetTimeClocks, IResponseGetTimeClocks } from '~/utils/interface/timeClock';

export const handleGetTimeClocks = createAsyncThunk<IResponseGetTimeClocks, IParamsGetTimeClocks>(
  GET_TIME_CLOCKS,
  async (params: IParamsGetTimeClocks = {}, { rejectWithValue }) => {
    try {
      const res = await timeClockApi.getTimeClocks(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
